<template>
  <NavBar />
  <router-view/>
  <FooterBar />
  <SpeedInsights />
</template>


<script setup>
import 'jquery/dist/jquery.min.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.scss'
import SpeedInsights  from '@vercel/speed-insights/vue';
</script>
<script>
import NavBar from './components/NavBar.vue'
import FooterBar from './components/FooterBar.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    FooterBar
  }
}
</script>

<style lang="scss">
@use '@/assets/style/common';
@use '@/assets/style/variables';
@use '@/assets/style/functions';

a {
  color: variables.$font-link-color;
}

a:hover {
 color: variables.$font-link-color;
 filter: brightness(120%); 
}

#app {
  font-family: 'Poppins', cursive;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: variables.$font-color;
  background: variables.$light-color;
}

body {
  background: variables.$light-color;
}
</style>